import { render, staticRenderFns } from "./CompanyChanger.vue?vue&type=template&id=d9b56900&scoped=true&"
import script from "./CompanyChanger.vue?vue&type=script&lang=js&"
export * from "./CompanyChanger.vue?vue&type=script&lang=js&"
import style0 from "./CompanyChanger.vue?vue&type=style&index=0&id=d9b56900&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b56900",
  null
  
)

export default component.exports